export default function () {
    var size = 0;
    for (var _i = 0, _a = this; _i < _a.length; _i++) {
        var node = _a[_i];
        ++size;
    } // eslint-disable-line no-unused-vars
    return size;
}
